<template>
  <div class="my-5">
    <hr />
    <ul class="nav lead font-weight-bold justify-content-center">
      <li title="Hoopsyard en Whatsapp" class="nav-item"><h3><a href="https://wa.me/+50763084298" rel="noopener" target="_blank" class="nav-link text-muted"><span class="icon-whatsapp" /></a></h3></li>
      <li title="Hoopsyard en Instagram" class="nav-item"><h3><a href="https://www.instagram.com/hoopsyard/" rel="noopener" target="_blank" class="nav-link text-muted"><span class="icon-instagram" /></a></h3></li>
    </ul>
  </div>
</template>

<script>
export default {
}
</script>
